import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnGU: CultureInfo = {
  name: 'en-GU',
  displayName: 'English (Guam)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-GU',
  parent: CultureInfoEn
};
